import { stringCompare } from '@mahawi/eshop-common/src/string-compare';
import { Table } from 'antd';
import { type ColumnsType } from 'antd/es/table';
import { type ColumnFilterItem, type Key } from 'antd/es/table/interface';
import React from 'react';

export interface LintDataType {
  key: string;
  languageTypeCode: string;
  lineNumber: number;
  ruleName: string;
  ruleDescription: string;
  line: string;
  detail: string;
}

function languageTypeCodeFilter(
  dataSource: LintDataType[],
): ColumnFilterItem[] {
  return [
    ...new Set(
      dataSource.map(
        ({ languageTypeCode }: LintDataType): string => languageTypeCode,
      ),
    ),
  ].map((code: string): ColumnFilterItem => ({ text: code, value: code }));
}

function buildColumns(dataSource: LintDataType[]): ColumnsType<LintDataType> {
  return [
    { title: 'Rule name', dataIndex: 'ruleName' },
    { title: 'Rule description', dataIndex: 'ruleDescription' },
    {
      title: 'Language type',
      dataIndex: 'languageTypeCode',
      sorter: (a: LintDataType, b: LintDataType): number =>
        stringCompare(a.languageTypeCode, b.languageTypeCode),
      filterSearch: true,
      filters: languageTypeCodeFilter(dataSource),
      onFilter: (value: boolean | Key, record: LintDataType): boolean =>
        record.languageTypeCode === value,
    },
    { title: 'Line number', dataIndex: 'lineNumber' },
    { title: 'Line', dataIndex: 'line' },
    { title: 'Detail', dataIndex: 'detail' },
  ];
}

export default function LintTable({
  dataSource,
}: {
  dataSource: LintDataType[];
}): React.ReactElement {
  if (dataSource.length === 0) {
    return <span>No errors, all fine</span>;
  }
  return <Table columns={buildColumns(dataSource)} dataSource={dataSource} />;
}
